<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-table :data="userLevels" resource="user-levels">
      <el-table-column prop="id" label="ID" width="50" />
      <el-table-column prop="level_name" label="名称" width="100" />
      <el-table-column prop="declaration" label="报单(件)" width="100" />
      <el-table-column prop="reward" label="推荐奖励" />
      <el-table-column prop="bill_amount" label="报单金额(元)" width="120" />
      <el-table-column prop="min_buy_num" label="起购数量(件)" width="120" />
      <el-table-column label="操作" width="80">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <!-- <row-destroy /> -->
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { getUserLevels } from '@/api/user-levels'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
  },
  data() {
    return {
      search: [],
      userLevels: [],
      page: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getUserLevels(newVal.query)
        this.userLevels = data
        this.page = meta
      },
      immediate: true,
    },
  },
}
</script>
